import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, userProfile, loading } = useAuth();
  const location = useLocation();

  // CRITICAL: If returning from bank payment gateway with success/fail status,
  // bypass auth check so the checkout page can render the payment result screen
  const searchParams = new URLSearchParams(location.search);
  const paymentStatus = searchParams?.get('payment_status');
  if (paymentStatus === 'success' || paymentStatus === 'fail' || paymentStatus === 'error') {
    return children;
  }

  if (loading) {
    return <div className="flex h-screen items-center justify-center">Yükleniyor...</div>;
  }

  if (!user) {
    // Redirect to login but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin) {
    // Check both metadata and profile role for robustness
    const isAdmin = userProfile?.role === 'admin' || user?.user_metadata?.role === 'admin';
    if (!isAdmin) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;